import { createAction, createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { select, put } from 'redux-saga/effects';
import { getArticle, getRegion } from 'common/selectors';
import { EffectR } from 'types/utils';
import { NavigationContext, PdpSectionMeta } from '../types';

export const RESET_NAVIGATION_CONTEXT = createAction(
  'navigation/NAVIGATION_CONTEXT/reset',
)<NavigationContext>();

export const navigationContext = createReducer<NavigationContext>({
  productId: null,
  regionCode: null,
}).handleAction([RESET_NAVIGATION_CONTEXT], (_, { payload }) => {
  return payload;
});

export const RESET_NAVIGATION_SECTIONS = createAction('navigation/NAVIGATION_SECTIONS/reset')<
  PdpSectionMeta[]
>();
export const RESET_NAVIGATION_SECTION = createAction(
  'navigation/NAVIGATION_SECTION/reset',
)<PdpSectionMeta>();
export const ADD_NAVIGATION_SECTION = createAction('navigation/NAVIGATION_SECTIONS/add')<PdpSectionMeta>();
export const REMOVE_NAVIGATION_SECTION = createAction('navigation/NAVIGATION_SECTIONS/remove')<
  Pick<PdpSectionMeta, 'sectionId'>
>();
export const GA_STICKY_PANEL_BUTTON_CLICK = createAction('navigation/GA_STICKY_PANEL_BUTTON_CLICK')<{
  title: string;
}>();

export const productNavigation = createReducer<PdpSectionMeta[]>([])
  .handleAction([RESET_NAVIGATION_SECTIONS], (_, { payload }) => payload)
  .handleAction([RESET_NAVIGATION_SECTION], (state, { payload }) => {
    const result = removeSection(Array.from(state), (s) => s.sectionId === payload.sectionId);
    result.push(payload);
    return result;
  })
  .handleAction([ADD_NAVIGATION_SECTION], (state, { payload }) => {
    const result = Array.from(state);
    if (!result.some((s) => s.sectionId === payload.sectionId)) {
      result.push(payload);
    }
    return result;
  })
  .handleAction([REMOVE_NAVIGATION_SECTION], (state, { payload }) =>
    removeSection(Array.from(state), (s) => s.sectionId === payload.sectionId),
  );

export function removeSection(result: PdpSectionMeta[], sectionSelector: (s: PdpSectionMeta) => boolean) {
  const idx = result.findIndex(sectionSelector);
  if (idx >= 0) {
    result.splice(idx, 1);
  }

  return result;
}

export const rootReducer = combineReducers({
  context: navigationContext,
  sectionMetas: productNavigation,
});

export function* doResetNavigationContext() {
  const regionCode = (yield select(getRegion)) as EffectR.Select<typeof getRegion>;
  const productId = (yield select(getArticle)) as EffectR.Select<typeof getArticle>;

  yield put(RESET_NAVIGATION_CONTEXT({ regionCode, productId }));
}
